import React from "react";
import { Select } from "antd";

import styles from "./style.scss";
import {
  parseFormControlValue,
  checkEmptyObject,
  showDropdownSearch,
  getWindowWidth
} from "../../../services/utils";
import { InputType, LocalStorageKey } from "../../../models/enums";
import { isSearchMobile, localStorage } from "../../../services";
import MobileRegistrationSelect from "./MobileRegistrationSelect";

export const notRegistredOption = {
  title: "Nije registriran",
  value: "1970-01-15T00:00:00Z",
}

const DropdownSelect = props => {
  const {
    placeholder = "Odaberite",
    title = "",
    isRequired = false,
    valueType = "",
    hasAnyValue = false,
    anyTitle = "Poništi",
    className = "",
    style = {},
    onChange,
    isDisabled = false,
    tyres = false,
    showPlaceholder = false,
    field,
    value: propValue,
    getPopupContainer
  } = props;

  // from current date next 12 month with years array of objects
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // Months are zero-based in JavaScript

  const options = Array.from({ length: 13 }, (_, index) => {
    const month = (currentMonth + index) % 12 || 12; // Wrap around to 12 if month is 0
    const year = currentYear + Math.floor((currentMonth + index - 1) / 12);
    return {
      title: `${month < 10 ? `0${month}` : month}.${year}.`,
      value: `${year}-${month < 10 ? `0${month}` : month}-15T00:00:00Z`,
    };
  });

  // add not registret option to the options array
  options.unshift(notRegistredOption);

  // if propValue dosen't exist in optiona array set propValue to undefined
  if (typeof propValue !== "undefined" && propValue[field] !== undefined) {
    const isValueInOptions = options.some(option => option.value === propValue[field]);
    if (!isValueInOptions) {
      onChange({ [field]: undefined });
    }
  }


  const getValue = () => {
    if (checkEmptyObject(propValue)) {
      return handleBooleanValue(propValue[field]);
    }

    return undefined;
  };

  const handleChange = option => {
    let value = option;

    if (value !== "") {
      if (valueType === InputType.boolean) {
        value = Boolean(value);
      }
    } else {
      onChange({ [field]: undefined });
      return;
    }

    if (tyres) {
      onChange({ ...propValue, ...parseFormControlValue([field], [value]) });
    } else {
      onChange(parseFormControlValue([field], [value]));
    }
  };

  const handleBooleanValue = value => {
    if (valueType === InputType.boolean) {
      return value ? 1 : 0;
    }

    return value;
  };

  const handleSearch = (input, option) =>
    option && option.props && option.props.children &&
    typeof option.props.children === "string" &&
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const showSearch = () => {
    const anyOptionValue = hasAnyValue ? 1 : 0;
    const optionsCount = options.length + anyOptionValue;

    return showDropdownSearch(optionsCount);
  };

  const allOptions = options.map(o => ({
    ...o,
    value: handleBooleanValue(o.value)
  }));

  const value = getValue();

  if (hasAnyValue && value) {
    allOptions.unshift({
      title: anyTitle,
      value: "",
      style: {
        borderBottom: "1px solid #e8e8e8"
      }
    });
  }


  if (isSearchMobile(getWindowWidth())) {
    return (
      <span style={style}>
        {!showPlaceholder && (
          <span
            className={`control-title ${isRequired ? "required" : ""} ${styles.label
              }`}
          >
            {title}
          </span>
        )}
        <MobileRegistrationSelect
          options={allOptions}
          value={value}
          valueType={valueType}
          placeholder={showPlaceholder ? title : placeholder}
          isDisabled={isDisabled}
          onChange={handleChange}
          title={title}
          field={field}
        />
      </span>
    );
  }

  return (
    <span className={className} style={style}>
      {showPlaceholder ? null : (
        <span className={`control-title ${isRequired ? "required" : ""}`}>
          {title}
        </span>
      )}
      <Select
        value={value}
        onChange={handleChange}
        placeholder={showPlaceholder ? title : placeholder}
        disabled={isDisabled}
        showSearch={showSearch()}
        optionFilterProp="children"
        filterOption={handleSearch}
        className={isDisabled ? styles.disabledSelect : ""}
        notFoundContent={"Nema rezultata"}
        getPopupContainer={getPopupContainer}
      >
        {allOptions.map((option, index) => (
          <Select.Option
            key={index /* eslint-disable-line */}
            value={option.value}
            style={option.style || {}}
          >
            {option.title}
          </Select.Option>
        ))}
      </Select>
    </span>
  );
};

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components/FormControls/RegistrationSelect/RegistrationSelect.tsx